import React from 'react'
import { Collection, WhenCollectionIsNotEmpty } from '@morningtrain/react-resources'
import { BooleanFilter, EnumFilter } from 'support/filters'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import CreateOnboardingTemplateButton from './partials/CreateOnboardingTemplateButton'
import { Link, useRouter } from '@morningtrain/react-navigation'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Table } from 'widgets/crud'
import OnClickTableRow from 'widgets/crud/OnClickTableRow'
import * as Columns from 'support/columns'
import { PaginationFilter } from '@morningtrain/react-filters'
import * as Icons from 'ui/icons'

export default function OnboardingTemplates () {
  const router = useRouter()

  const handleClick = (model, id) => {
    router.navigate('app.onboarding.template', { onboarding_checklist_template: id })
  }

  return (
    <AdminPageWithSmartview withGlobalDepartmentFilter={false}>
      <Translator namespace='onboarding'>
        <UI.CardGroup>

          <UI.PageHeader title={<TranslatedTitle name='titles.templates' />}>
            <UI.ButtonWrap>
              <Link route='app.onboarding.overview'>
                <UI.Button>
                  <Icons.ArrowLeft className='mr-2' />
                  <span><Translation name='onboarding.actions.back_to_overview' /></span>
                </UI.Button>
              </Link>
              <CreateOnboardingTemplateButton />
            </UI.ButtonWrap>
          </UI.PageHeader>

          <UI.Card>
            <Collection resourceName='onboarding.onboarding_checklist_templates'>
              <UI.TableHeader>
                <EnumFilter
                  defaultValue={null}
                  enum='employment_type'
                  allowNull
                  name='employment_type'
                  placeholder='-'
                  label={<Translation name='onboarding.filters.employment_type' />}
                />
                <BooleanFilter
                  defaultValue
                  name='active' allowNull
                  label={<Translation name='onboarding.filters.active' />}
                />
              </UI.TableHeader>

              <WhenCollectionIsNotEmpty>
                <Translator namespace='checklists.columns'>
                  <Table row={<OnClickTableRow callback={handleClick} />}>
                    <Columns.Text name='name' />
                    <Columns.Boolean name='active' />
                  </Table>
                </Translator>
              </WhenCollectionIsNotEmpty>

              <PaginationFilter />
            </Collection>
          </UI.Card>
        </UI.CardGroup>
      </Translator>
    </AdminPageWithSmartview>
  )
}
